const mapSentiments = sentiments => ({
  positive: sentiments.positive,
  neutral: sentiments.neutral,
  negative: sentiments.negative,
})

const mapTopic = topic => ({
  topic_id: topic.topic_id,
  name: topic.name,
  note_count: topic.note_count,
  aggregated_sentiment: topic.aggregated_sentiment,
})

const mapCounts = counts => ({
  all: counts.all,
  positive: counts.positive,
  neutral: counts.neutral,
  negative: counts.negative,
})

const mapNote = note => ({
  note_text: note.note_text,
  return_id: note.return_id,
  order_name: note.order_name,
  return_date: note.return_date,
  sentiment: note.sentiment,
})

const mapResponse = response => ({
  topic: response.topic ? mapTopic(response.topic) : response.topic,
  counts: response.counts ? mapCounts(response.counts) : response.counts,
  sentiments: response.sentiments ? mapSentiments(response.sentiments) : response.sentiments,
  count: response.count,
  next: response.next,
  previous: response.previous,
  results: response.results ? response.results.map(mapNote) : response.results,
})

export const transformResponseGetCustomerNotesByTopic = response => (response ? mapResponse(response) : response)
